import { Controller } from "stimulus";

export default class extends Controller {
  private removeTimer: number;

  private get openClass(): string {
    return this.data.get("open-class") || "is-open";
  }

  disconnect(): void {
    if (this.removeTimer) {
      clearTimeout(this.removeTimer);
    }
  }

  close(): void {
    this.element.classList.remove(this.openClass);

    this.removeTimer = window.setTimeout(() => {
      this.element.remove();
    }, 300);
    window.location.reload();
  }
}
